<template>
  <div class="saude-mental">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Saúde mental</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atendimento psicológico online com profissionais qualificados
          </h5>
        </div>
      </v-container>
    </div>

    <v-container class="pa-6">
      <div class="text-center">
        <v-icon size="64" color="primary" class="mb-4">mdi-head-heart-outline</v-icon>

        <h4 class="secondary-font text--secondary">
          Aqui você encontra um espaço seguro,
          confidencial e acolhedor para conversar com um profissional de psicologia.
        </h4>

        <h6 class="secondary-font text--secondary mt-12">
          <i>Clique no botão abaixo para buscar uma sala de atendimento disponível.</i>
        </h6>

        <div v-if="loading" class="mt-12">
          <v-progress-circular indeterminate color="primary" width="3"></v-progress-circular>
          <h5 class="secondary-font text--secondary mt-4">Buscando sala disponível...</h5>
        </div>

        <v-btn v-else color="primary" class="secondary-font text-capitalize font-weight-black mt-8" elevation="2"
          rounded large @click="buscarSala">
          Buscar sala
        </v-btn>
      </div>
    </v-container>

    <v-dialog v-model="dialogSalaEncontrada" persistent max-width="500">
      <v-card>
        <v-card-text class="text-center pa-6">
          <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
          <h4 class="secondary-font">Sala encontrada!</h4>
          <h5 class="secondary-font text--secondary mt-3">
            Um profissional está disponível e aguardando você na sala de atendimento.
          </h5>
        </v-card-text>
        <v-card-actions class="d-flex flex-column align-stretch pa-4 pt-0">
          <v-btn color="primary" block class="mb-2 mx-0 secondary-font text-capitalize font-weight-black" rounded large
            @click="entrarNaSala">
            Entrar na sala
          </v-btn>
          <v-btn text outlined color="grey" block class="mx-0 secondary-font text-capitalize"
            @click="dialogSalaEncontrada = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SaudeMental',
  data() {
    return {
      loading: false,
      dialogSalaEncontrada: false
    }
  },
  methods: {
    async buscarSala() {
      this.loading = true
      const delay = 2500 + Math.random() * 500
      await new Promise(resolve => setTimeout(resolve, delay))
      this.loading = false
      this.dialogSalaEncontrada = true
    },
    entrarNaSala() {
      this.$router.push({ name: 'saude-mental-sala' })
    }
  }
}
</script>
